import { useState, useEffect } from 'react';

type Theme = 'light' | 'dark';

export function useTheme() {
    const [theme, setTheme] = useState<Theme>(() => {
        // Check if theme is stored in localStorage
        const storedTheme = localStorage.getItem('theme') as Theme | null;

        // Check for system preference if no stored theme
        if (!storedTheme) {
            return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        }

        return storedTheme;
    });

    useEffect(() => {
        // Update localStorage when theme changes
        localStorage.setItem('theme', theme);

        // Update document attributes
        const root = window.document.documentElement;

        if (theme === 'dark') {
            root.classList.add('dark');
        } else {
            root.classList.remove('dark');
        }
    }, [theme]);

    return { theme, setTheme };
} 